/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, arrayOf, func, object, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    listStyling: {
        height: 'auto',
        background: theme.palette.cgc?.cgcListColor || '#fff',
        listStyle: 'none',
        boxShadow: `0px 2px 8px ${theme.palette.cgc?.cgcListShadow || 'rgba(0, 0, 0, 0.25)'}`,
        borderRadius: 10,
        padding: 10,
        [theme.breakpoints.down(1660)]: {
            maxHeight: 250,
            minHeight: 250,
            overflowY: 'scroll',
        },
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            bottom: '100%',
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'absolute',
            bottom: '100%',
            width: '100%',
        },
    },
    optionListButton: {
        padding: 10,
        width: '100%',
        position: 'relative',
        background: theme.palette.cgc?.cgcOptionList || '#f1f1f1',
        border: `1px solid ${theme.palette.cgc?.cgcButtonBorder || 'transparent'}`,
        borderRadius: 5,
        outline: 'none',
        fontWeight: 700,
        fontSize: 20,
        fontFamily: 'roboto',
        '&:focus': {
            border: `1px solid ${theme.palette.cgc?.cgcButtonBorder || '#8020BB'}`,
        },
    },
    listFonts: {
        padding: '5px 2px',
    },
    optionFontButton: {
        padding: 10,
        width: '100%',
        background: theme.palette.cgc?.cgcOptionList || '#f1f1f1',
        border: `1px solid ${theme.palette.cgc?.cgcButtonBorder || ' transparent'}`,
        borderRadius: 5,
        outline: 'none',
        fontWeight: 'bold',
        fontSize: 20,
        '&:focus': {
            border: `1px solid ${theme.palette.cgc?.cgcButtonBorder || '#8020BB'}`,
        },
    },
    optionListColor: {
        height: 20,
        width: 20,
        borderRadius: '50%',
        display: 'inline-flex',
        position: 'absolute',
        left: 10,
        marginTop: 2,
    },
    optionColorName: {
        fontWeight: 400,
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            fontSize: 12,
            marginLeft: 10,
        },
    },
    buttonWrapper: {
        padding: '5px 20px 10px',
    },
    doneListButton: {
        padding: 10,
        width: '100%',
        background: theme.palette.cgc?.doneButtonColor || '#000000',
        color: theme.palette.cgc?.doneButtonTextColor || '#fff',
        border: `1px solid ${theme.palette.cgc?.doneButtonTextColor || 'transparent'}`,
        fontWeight: 'bold',
        textAlign: 'center',
        borderRadius: 5,
        outline: 'none',
        fontSize: 15,
        fontFamily: 'roboto',
    },
});
const ToolbarList = ({
    tool, onClick, classes, showList, handleList,
}) => (
    <>
        {showList
            ? (
                <ul className={classes.listStyling}>
                    {tool?.list?.map((item) => {
                        const style = {
                            [tool.type]: item?.value,
                        };
                        switch (tool.type) {
                            case 'fontFamily':
                                return (
                                    <li className={classes.listFonts}>
                                        <button type="button" onClick={() => onClick(tool?.type, item?.value)} style={style} className={classes.optionFontButton}>
                                            {item?.label}
                                        </button>
                                    </li>
                                );
                            case 'color':
                                return (
                                    <li className={classes.listFonts}>
                                        <button type="button" onClick={() => onClick(tool.type, item.value)} className={classes.optionListButton}>
                                            <span className={classes.optionListColor} style={{ backgroundColor: item.value }} />
                                            <span className={classes.optionColorName}>{item?.label}</span>
                                        </button>
                                    </li>
                                );
                            default:
                                return  null;
                        }
                    })}
                    <div className={classes.buttonWrapper}>
                        <button
                            type="button"
                            className={classes.doneListButton}
                            onClick={handleList}
                        >
                            Done
                        </button>
                    </div>
                </ul>
            ) : ''}
    </>
);

ToolbarList.propTypes = {
    classes: object.isRequired,
    tool: shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    }).isRequired,
    onClick: func.isRequired,
    showList: func.isRequired,
    handleList: bool.isRequired,
};

export default withStyles(styles)(ToolbarList);
